import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { GlobalComponent } from 'src/app/global-component';
import { BehaviorSubject, Observable, } from 'rxjs';
import { ClientBaseModel } from 'src/app/core/models/members/client/client-base-model';
import { ClientSearchModel } from 'src/app/core/models/members/client/client-search-model';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { BaseListService } from './base-list.service';

@Injectable({
  providedIn: 'root'
})
export class ClientListService extends BaseListService {

  defaultClientListState: ClientSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: '',
    number: '',
    lastName: '',
    name: '',
    clientId: '',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    email: '',
    sortColumn: '',
    sortDirection: '',
    searchTerm: '',
    status: undefined,
    isEnabled: undefined
  };

  private _resultItems$ = new BehaviorSubject<ClientBaseModel[]>([]);

  protected override _state: ClientSearchModel = { ...this.defaultClientListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get name() { return `${this._state.name}`; }

  set name(name: string) { this._set({ name }); }
  set status(status: any) { this._set({ status }); }
  set isEnabled(isEnabled: any) { this._set({ isEnabled }); }


  protected _search(): Observable<SearchResultModel<ClientBaseModel>|undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getClients(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultClientListState };
    this._resultItems$.next(new Array<ClientBaseModel>());
    this._total$.next(0);
  }
  
}
